import request from '@/router/axios'
//站内信
export function GetStationNewsList(query) {
    return request({
        url: '/api/services/app/FrontStationNews/GetStationNewsList',
        method: 'post',
        data: query
    })
}
// 获取banner列表
export function GetBannerList(query) {
    return request({
        url: '/api/services/app/CommonApi/GetBannerList',
        method: 'post',
        data: query
    })
}
// 获取新闻图片列表
export function GetPhotoList(query) {
    return request({
        url: '/api/services/app/Photo/GetPhotoList',
        method: 'post',
        data: query
    })
}
// 新闻动态列表
export function GetNewsList(query) {
    return request({
        url: '/api/services/app/Newsapi/GetNewsList',
        method: 'post',
        data: query
    })
}
// 新闻详情
export function GetNewsDetailsList(query) {
    return request({
        url: '/api/services/app/NewsDetails/GetNewsDetailsList',
        method: 'post',
        data: query
    })
}
// 通知公告列表
export function GetNotificList(query) {
    return request({
        url: '/api/services/app/Photo/GetNotificList',
        method: 'post',
        data: query
    })
}
// 测试班列表
export function GetExaminerClassList(query) {
    return request({
        url: '/api/services/app/TestClass/GetExaminerClassList',
        method: 'post',
        data: query
    })
}
// 考评员列表
export function GetExaminerClassList2(query) {
    return request({
        url: '/api/services/app/ExaminerClass/GetExaminerClassList',
        method: 'post',
        data: query
    })
}
// 精彩图片视频列表
export function GetPhotoVideosList(query) {
    return request({
        url: '/api/services/app/Photo/GetPhotoVideosList',
        method: 'post',
        data: query
    })
}
// 合作伙伴列表
export function GetParterList(query) {
    return request({
        url: '/api/services/app/CommonApi/GetParterList',
        method: 'post',
        data: query
    })
}
// 常见问题列表
export function GetQuestionsList(query) {
    return request({
        url: '/api/services/app/Photo/GetQuestionsList',
        method: 'post',
        data: query
    })
}
// 联系我们
export function GetContactUsList(query) {
    return request({
        url: '/api/services/app/AboutUs/GetContactUsList',
        method: 'post',
        data: query
    })
}
// 考评员列表
export function GetUserCoachList(query) {
    return request({
        url: '/api/services/app/UserCoachApi/GetUserCoachList',
        method: 'post',
        data: query
    })
}
//考评员详情
export function GetExaminerDetailsList(query) {
    return request({
        url: '/api/services/app/ExaminerClass/GetExaminerDetailsList',
        method: 'post',
        data: query
    })
}
// 测试机构列表
export function GetTestMechList(query) {
    return request({
        url: '/api/services/app/TestMechanism/GetTestMechList',
        method: 'post',
        data: query
    })
}
// 获取省市地区
export function GetDistrictList(query) {
    return request({
        url: '/api/services/app/CommonApi/GetDistrictList',
        method: 'post',
        data: query
    })
}
// 获取省市地区
export function Getexpressfee(query) {
    return request({
        url: '/api/services/app/AthleteCenter/Getexpressfee',
        method: 'post',
        data: query
    })
}
// 级别列表
export function GetTestClassLevel(query) {
    return request({
        url: '/api/services/app/CommonApi/GetTestClassLevel',
        method: 'post',
        data: query
    })
}

// 运动员证书查询
export function OpenQuery(query) {
    return request({
        url: '/api/services/app/CommonApi/OpenQuery',
        method: 'post',
        data: query
    })
}

//获取字典表数据
export function GetDicData(query) {
    return request({
        url: '/api/services/app/CommonApi/GetDicData',
        method: 'post',
        data: query
    })
}

//物流查询
export function GetSFData(query) {
    return request({
        url: '/api/services/app/SF/GetSFData',
        method: 'post',
        data: query
    })
}

// 设置开票信息
export function UpdateInvoiceInfo(query) {
    return request({
        url: '/api/services/app/InvoiceApi/UpdateInvoiceInfo',
        method: 'post',
        data: query
    })
}

// 读取开票信息
export function GetUserInvoiceInfo(query) {
    return request({
        url: '/api/services/app/InvoiceApi/GetUserInvoiceInfo',
        method: 'post',
        data: query 
    })
}

// 支付获取图片
export function GDCloudPay(query) {
    return request({
        url: '/api/services/app/CommonApi/GDCloudPay',
        method: 'post',
        data: query 
    })
}
// 支付获取图片    2020年8月27日 16:37:00 XXL
export function GDCloudPayV1(query) {
    return request({
        url: '/api/services/app/CommonApi/GDCloudPayV1',
        method: 'post',
        data: query 
    })
}
export function GDCloudPayV2(query) {
    return request({
        url: '/api/services/app/CommonApi/GDCloudPayV2',
        method: 'post',
        data: query 
    })
}

// 轮询查询 订单状态
export function GetPaymentStatus(query) {
    return request({
        url: '/api/services/app/CommonApi/GetPaymentStatus',
        method: 'post',
        data: query 
    })
}